import { render, staticRenderFns } from "./MobileDesktopNotice.vue?vue&type=template&id=ac01fbb2"
import script from "./MobileDesktopNotice.vue?vue&type=script&lang=js"
export * from "./MobileDesktopNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports